module.exports = "/assets/packs/images/e7aeb3c54f1df9d701171dc0cc4cb3fb.png";